import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

// const ls = new SecureLS({
//   isCompression: false
// });

export default createStore({
  plugins: [
    createPersistedState({
      key: "ECOBLOX-CLIENT",
      // storage: {
      //   // getItem: (key) => ls.get(key),
      //   // setItem: (key, value) => ls.set(key, value),
      //   // removeItem: (key) => ls.remove(key)
      // }
    }),
  ],
  state: {
    authentication: {
      accessToken: null,
      expiresIn: 0,
      name: "",
    },
    rememberMe: {
      email: "",
      password: "",
      rememberMe: false,
    },
  },
  getters: {
    isAuthenticated(state): boolean {
      return state.authentication.accessToken !== null;
    },
    getAuthenticationAccessToken(state): boolean | null {
      return state.authentication.accessToken;
    },
    getAuthenticationName(state): string {
      return state.authentication.name;
    },
    isRememberMeSet(state): boolean {
      return state.rememberMe.rememberMe;
    },
  },
  mutations: {
    setAuthentication(state, data) {
      state.authentication = data;
    },
    setRememberMe(state, data) {
      state.rememberMe = data;
    },
    setLogout(state) {
      state.authentication = {
        accessToken: null,
        expiresIn: 0,
        name: "",
      };
    },
  },
  actions: {
    setAuthentication({ commit }, data) {
      commit("setAuthentication", data);
    },
    setRememberMe({ commit }, data) {
      commit("setRememberMe", data);
    },
    setLogout({ commit }) {
      commit("setLogout");
    },
  },
});
